import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'glamorous';
import classnames from 'classnames';
import { lighten, darken } from 'polished';
import Button from 'react-toolbox/lib/button';
import Card from 'react-toolbox/lib/card';
import FontIcon from 'react-toolbox/lib/font_icon';
import ScrollToMe from '../../../common/components/ScrollToMe';
import styles from './ErrorList.css';

export const MessageType = {
  error: 'error',
  success: 'success',
  warning: 'warning',
};

const MessageIcon = {
  error: 'error',
  success: 'check_circle',
  warning: 'warning',
};

const renderActionObjects = (actions, container) => {
  const { className, ...containerProps } = container;
  if (
    actions &&
    actions.length &&
    actions.every(action => typeof action === 'object')
  ) {
    return (
      <div
        className={classnames(styles.actionContainer, className)}
        {...containerProps}
      >
        {actions.map(action => {
          return <Button key={action.label} {...action} />;
        })}
      </div>
    );
  }
  return null;
};

// TODO: deprecate success boolean being used in other places
// TODO: rename this component since it's not only errors
const ErrorList = ({
  errors = [],
  success = false,
  type = MessageType.error,
  actions,
  item = {},
  container = {},
  list = {},
  actionContainer = {},
  renderInListItem,
  theme: { colors = {} } = {},
  offsetTop = 0,
}) => {
  const listType = success ? MessageType.success : type;
  const { className: containerClass, ...containerProps } = container;
  const { className: listClass, ...listProps } = list;

  let backgroundColor;
  let color;

  // get colors
  switch (listType) {
    case MessageType.warning: {
      backgroundColor = lighten(0.3, colors.gold || 'gold');
      color = darken(0.3, colors.gold || 'gold');
      break;
    }
    case MessageType.success: {
      backgroundColor = '#8ef1bc';
      color = darken(0.25, '#00AD50');
      break;
    }
    default: {
      backgroundColor = lighten(0.44, '#E53935');
      color = darken(0.14, '#E53935');
      break;
    }
  }

  return !errors.length ? null : (
    <Card
      className={classnames(styles.messageContainer, containerClass)}
      style={{
        backgroundColor,
        color,
      }}
      {...containerProps}
    >
      <ScrollToMe offsetTop={offsetTop} />
      <ul className={classnames(styles.messageList, listClass)} {...listProps}>
        {errors.map((error, i) => (
          <li key={i} {...item}>
            {!!renderInListItem && typeof renderInListItem === 'function' ? (
              renderInListItem()
            ) : (
              <FontIcon
                value={MessageIcon[listType]}
                className={styles.messageIcon}
              />
            )}
            <span>{error}</span>
          </li>
        ))}
      </ul>
      {typeof actions === 'function'
        ? actions()
        : renderActionObjects(actions, actionContainer)}
    </Card>
  );
};

ErrorList.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  success: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(MessageType)),
  container: PropTypes.object,
  list: PropTypes.object,
  item: PropTypes.object,
  actionContainer: PropTypes.object,
  renderInListItem: PropTypes.func,
  actions: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func,
      })
    ),
  ]),
};

export default withTheme(ErrorList);



// WEBPACK FOOTER //
// ./src/common/components/ErrorList/index.js